import React from 'react';

import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

const Layout = styled.div`
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 0px;
  padding-top: 0px;
`;

const Table = styled.div`
  display: flex 0 0 auto;
  flex-direction: column;
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 24px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  text-overflow: ellipsis;
`;

const Col = styled.div`
  text-overflow: ellipsis;
  width: auto;
  overflow: hidden;
  flex: 1;
  opacity: 1;
  color: ${(props) => {
    switch (props.color) {
      case 'title':
        return '#43b02a';
      case 'sales':
        return '#444b62';
      default:
        return '#838aa2';
    }
  }};
  text-align: ${(props) => props.align || 'left'};
  font-size: ${(props) => props.size || '14px'};
  padding-bottom: ${(props) => props.padding || ''};
`;

const TextTitle = styled.p`
  font-size: 16px;
  line-height: 19px;
  color: #838aa2;
  letter-spacing: 0.32px;
  opacity: 1;
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 0px;
  padding-top: 0px;
`;

const ModalTableSmall = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <TextTitle>Detalle de últimos movimientos en tu Saldo Disponible</TextTitle>

      <Table>
        <Row>
          <Col color="title">{t('helpModalTable.modal.detail')}</Col>
          <Col color="title" align="right">
            {t('helpModalTable.modal.mount')}
          </Col>
        </Row>
        <Row>
          <Col color="sales" size="14px">
            Retiro de fondos
          </Col>
          <Col align="right" color="sales" size="14px" padding="8px">
            {t('helpModalTable.modal.exampleMount')}
          </Col>
        </Row>

        <Row>
          <Col color="title">{t('helpModalTable.modal.code')}</Col>
          <Col color="title" align="right">
            {t('helpModalTable.modal.date')}
          </Col>
        </Row>
        <Row>
          <Col>{t('helpModalTable.modal.exampleCode')}</Col>
          <Col align="right" padding="8px">
            {t('helpModalTable.modal.exampleDate')}
          </Col>
        </Row>
      </Table>
    </Layout>
  );
};

export default ModalTableSmall;
